export default "__VITE_ASSET__DGyQb1bW__"